import Vue from 'vue'
import vueSocialSharing from 'vue-social-sharing'

Vue.use(vueSocialSharing)

const el = document.querySelector('#social-app')
if (el != null) {
  // eslint-disable-next-line no-unused-vars
  const app = new Vue({
    el: '#social-app',
    name: 'vue-instance'
  })
}
